__webpack_require__.p = "/friday-project/";